import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/sections/PageHero";
import hero from "@/assets/hero-home-aesthetic.webp";

const Integritetspolicy = () => {
  return (
    <>
      <SEO
        title="Integritetspolicy | Cloud Redovisning"
        description="Läs hur Cloud Redovisning behandlar personuppgifter när du kontaktar oss om bokföring, lön, bokslut, deklaration eller rådgivning."
      />
      <PageHero
        eyebrow="Integritet"
        title={
          <>
            Så hanterar vi <span className="italic text-primary">personuppgifter</span>.
          </>
        }
        description="Här beskriver vi hur Cloud Redovisning & Administration behandlar personuppgifter när du kontaktar oss via formulär, e-post eller telefon."
        image={hero}
        imageAlt="Integritetspolicy för Cloud Redovisning"
      />

      <section className="py-20 md:py-24">
        <div className="container-narrow prose-article max-w-none">
          <h2>Personuppgiftsansvarig</h2>
          <p>
            Cloud Redovisning & Administration är personuppgiftsansvarig för behandlingen av
            personuppgifter som samlas in via webbplatsen.
          </p>

          <h2>Vilka uppgifter vi behandlar</h2>
          <p>
            När du kontaktar oss kan vi behandla namn, e-postadress, telefonnummer, företagsnamn
            och det innehåll du själv lämnar i ditt meddelande.
          </p>

          <h2>Varför vi behandlar uppgifterna</h2>
          <p>
            Vi behandlar uppgifterna för att kunna besvara frågor, följa upp förfrågningar och
            inleda dialog om bokföring, löneadministration, bokslut, deklaration eller rådgivning.
          </p>

          <h2>Rättslig grund</h2>
          <p>
            Behandlingen sker med stöd av berättigat intresse när vi besvarar inkommande
            förfrågningar och, i förekommande fall, för att kunna förbereda eller fullgöra avtal.
          </p>

          <h2>Hur länge uppgifterna sparas</h2>
          <p>
            Uppgifterna sparas inte längre än nödvändigt för att hantera kontakten eller uppfylla
            rättsliga skyldigheter.
          </p>

          <h2>Dina rättigheter</h2>
          <p>
            Du har rätt att begära tillgång till dina personuppgifter, rättelse, radering,
            begränsning av behandling och att invända mot behandling. Du har också rätt att lämna
            klagomål till Integritetsskyddsmyndigheten.
          </p>

          <h2>Kontakt</h2>
          <p>
            Har du frågor om hur vi behandlar personuppgifter är du välkommen att kontakta oss på{" "}
            <a href="mailto:info@cloudredovisning.se">info@cloudredovisning.se</a> eller{" "}
            <a href="tel:0703036345">070-303 63 45</a>.
          </p>
        </div>
      </section>
    </>
  );
};

export default Integritetspolicy;
